import { createSlice } from '@reduxjs/toolkit';
import { updateCakeDetails } from './api';

interface CakeEditState {
  loading: boolean;
  error: string | null;
  lastUpdated: string | null;
}

const initialState: CakeEditState = {
  loading: false,
  error: null,
  lastUpdated: null,
};

const cakeEditSlice = createSlice({
  name: 'cakeEdit',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.lastUpdated = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCakeDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCakeDetails.fulfilled, (state, _action) => {
        state.loading = false;
        state.error = null;
        state.lastUpdated = new Date().toISOString();
      })
      .addCase(updateCakeDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, resetState } = cakeEditSlice.actions;
export default cakeEditSlice.reducer;
